/**
 * Utilitários de formatação e normalização — Re Leve IA
 * Lida com valores reais da planilha (strings BR, datas, nulls, anônimos)
 */

export function parseBrazilianCurrency(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    // Remove "R$", espaços e pontos de milhar; troca vírgula por ponto
    const cleaned = value.replace(/R\$\s?/g, '').replace(/\./g, '').replace(',', '.').trim();
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }
  return null;
}

export function formatCurrencyBR(value) {
  const num = typeof value === 'number' ? value : parseBrazilianCurrency(value);
  if (num === null || isNaN(num)) return 'Não informado';
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatDateBR(value) {
  if (!value) return 'Não informado';
  if (typeof value === 'string') {
    // Já está no formato dd/mm/aaaa ou similar?
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value.trim())) return value.trim();
    // Tenta converter ISO ou outros formatos
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('pt-BR');
    }
    return value;
  }
  if (value instanceof Date) {
    return value.toLocaleDateString('pt-BR');
  }
  return 'Não informado';
}

export function safeText(value, fallback = 'Não informado') {
  if (value === null || value === undefined) return fallback;
  const str = String(value).trim();
  if (str === '' || str === '-' || str === 'null' || str === 'undefined') return fallback;
  return str;
}

export function normalizeText(value) {
  if (!value) return '';
  return String(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

export function getField(obj, possibleKeys, fallback = null) {
  if (!obj) return fallback;
  for (const key of possibleKeys) {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      return obj[key];
    }
  }
  return fallback;
}
